import { CAN_REDO_COMMAND, COMMAND_PRIORITY_LOW, REDO_COMMAND } from "lexical";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Redo2 } from "lucide-react";

export function RedoButton() {
    const [editor] = useLexicalComposerContext();
    const [canRedo, setCanRedo] = useState(false);

    useEffect(() => {
        return editor.registerCommand(
            CAN_REDO_COMMAND,
            (payload) => {
                setCanRedo(payload);
                return false;
            },
            COMMAND_PRIORITY_LOW,
        );
    }, [editor]);

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            disabled={!canRedo}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor.dispatchCommand(REDO_COMMAND, undefined)}
            title="Redo"
            aria-label="Redo"
        >
            <Redo2 size={16} />
        </button>
    );
}
